/* eslint-disable jsx-a11y/alt-text */
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import phone from "../../../assets/svg/newcal.svg";
import threePhone from "../../../assets/images/third2.png";
import styles from "../third/third.module.scss";
const Third = () => {
  const navigate = useNavigate();
  return (
    <div className={`${styles.third_wrapper} `}>
      <Container>
        <div className={styles.third_main}>
          <Row className="align-items-center">
            <Col lg={7}>
              <div className={styles.third}>
                <p className={styles.call}>Need An Inspection?</p>
                <p className={styles.require}>
                  Whether you're a builder, contractor, homeowner, or part of a
                  township, schedule your inspection with ease.
                </p>
                <p className={styles.create}>
                  Just give us a call or Contact us-
                </p>
                <div className={styles.btn_new}>
                  <p className={styles.button_}>
                    <img src={phone} />
                    <a
                      style={{ textDecoration: "none" }}
                      href="tel:+19734494171"
                    >
                      973-449-4171
                    </a>
                  </p>
                  <div className={styles.contact_btn}>
                    <button
                      onClick={() => {
                        navigate("/contactus");
                      }}
                    >
                      Contact Us
                    </button>
                  </div>
                </div>

                <p className={styles.create}>
                  If you already have an account with us, simply{" "}
                  <a href="https://vendor.cidusa.net" target="_blank">
                    Sign in.
                  </a>
                </p>
              </div>
            </Col>
            {window.innerWidth > 992 && (
              <Col lg={5}>
                <div className={styles.image_}>
                  <img src={threePhone} />
                </div>
              </Col>
            )}
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Third;
